//#region src/components/ui/command/locale/en_US.ts
var e = {
	title: "Command Palette",
	description: "Search for a command to run..."
};
//#endregion
export { e as commandLocale };

//# sourceMappingURL=en_US.js.map